export function coordinates(point) {
  if ([point.latitude, point.longitude].some(value => value == null || typeof value === 'boolean' || String(value).trim() === '')) return null;
  const latitude = Number(point.latitude), longitude = Number(point.longitude);
  return Number.isFinite(latitude) && Number.isFinite(longitude) && Math.abs(latitude) <= 90 && Math.abs(longitude) <= 180
    ? { latitude, longitude } : null;
}

export function distanceKm(a, b) {
  const rad = degrees => degrees * Math.PI / 180;
  const dLat = rad(b.latitude - a.latitude), dLon = rad(b.longitude - a.longitude);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.latitude)) * Math.cos(rad(b.latitude)) * Math.sin(dLon / 2) ** 2;
  return 6371 * 2 * Math.atan2(Math.sqrt(Math.min(1, h)), Math.sqrt(Math.max(0, 1 - h)));
}

export function nearbyPoints(points, location) {
  return points.map(point => ({ ...point, distance: location && coordinates(point) ? distanceKm(location, coordinates(point)) : null }))
    .sort((a, b) => (a.distance ?? Infinity) - (b.distance ?? Infinity));
}

export function mapSearchUrl(point) {
  return `https://2gis.ru/search/${encodeURIComponent(point.address || point.name)}`;
}
